export const HOLDING_BACK_QUESTION = `What's holding you back?`

export const HOLDING_BACK_OPTIONS = [
  { key: 'overthink', i18nKey: 'overthink' },
  { key: 'tooBusy', i18nKey: 'tooBusy' },
  { key: 'whereToStart', i18nKey: 'whereToStart' },
  { key: 'loseMotivation', i18nKey: 'loseMotivation' },
  { key: 'notEnoughPractice', i18nKey: 'notEnoughPractice' },
  { key: 'afraidToMessUp', i18nKey: 'afraidToMessUp' },
  { key: 'chaoticRoutine', i18nKey: 'chaoticRoutine' },
  { key: 'other', i18nKey: 'other' },
] as const
